<template>
  <div class="page container">

    <div class="row mt-2">

      <div class="col-12 text-left">

        <router-link v-show="currentePedido" class='btn btn-primary mt-0 mb-5 hideprint' :to="'/admin/pedidos/'+$route.params.listaid"> voltar para lista de pedidos </router-link>

        <h3> Pedidos <b v-if="currentePedido"> de {{currentePedido.cliente.nome}}</b>  <button @click="imprimir" class='btn btn-primary hideprint' style="float:right"> <PrinterIcon /> Imprimir </button>  </h3>

        <hr />

        <div >

      

          <div class="list-group">


            <div class=" ">
              <div class="row">
                <div class="col">

               
                  <h5 class='mt-1 mb-2'><small class="mb-1">{{currentePedido._datapedido}} </small></h5>
                  <h5 class="mb-2 mt-3"> Nome: <b>{{currentePedido.cliente.nome}}</b> </h5>
                  <h5 class="mb-2"> Telefone: <b>{{currentePedido.cliente.telefone}}</b> </h5>
                  <h5 class="mb-2"> Endereço: <b> {{currentePedido.cliente.endereco}}</b> </h5>

                
                  
                        <h5 class="">
                  Status: <a @click='tooglepago(currentePedido)' v-if="currentePedido.pago==false" class='btn btn-red btn-sm'> <SquareIcon />  Não Pago </a>
                  <a @click='tooglepago(currentePedido)' v-if="currentePedido.pago==true" class='btn btn-green btn-sm'> <CheckSquareIcon />  Pago </a>
                </h5>
              
                </div>
       
              </div>

              <div class="row mt-3">
                <div class="col">

                  <h5 class="mt-3"> <b>Lista de Produtos</b> </h5>
                  <hr />
                  <ul class="list-group list-group-flush resumo-compra">

                    <li v-for="produto in currentePedido.produtos" :key="produto.id" class="list-group-item">
                      <b class='nome'>{{produto.nome}}- {{produto.quantidade}} {{produto.medida}} </b> 
                    </li>

                  </ul>

                    <h5 class='mt-5 mb-4' v-if="currentePedido.cliente.observacao != ''">
                      <b>Observação do cliente:</b><br/>
                       {{currentePedido.cliente.observacao}}
                  </h5>


                  <h3 class="mb-5 mt-6">Total <b> R$ {{currentePedido.total}} </b> </h3>

                

                 <button class="btn btn-default btn-sm hideprint mt-3" @click="apagarPedido(currentePedido)"> <Trash2Icon/> Apagar Pedido </button>

                </div>

              </div>
            </div>

          </div>




        </div>

      </div>


    </div>


  </div>





</template>

<script>


import has from 'lodash/has'

import { SquareIcon, CheckSquareIcon, Trash2Icon, PrinterIcon } from 'vue-feather-icons'
export default {
      
    components: {SquareIcon, CheckSquareIcon, Trash2Icon, PrinterIcon},

    computed:{

      pedidos:function(){
          return this.$store.getters.pedidos
      },
     
      
      currentePedido:function(){
          if(has(this.$route,'params.pedidoid')){
        
            return _.find(this.pedidos,{id:this.$route.params.pedidoid})
          }else{
            return false
          }
      },
    
  },

  created:function(){
    // this.$store.dispatch('getPedidos')
  },

  methods:{

      getTotalProdutos:function(pedidos){
          let produtos = {}

          pedidos.forEach(pedido=>{
              pedido.produtos.forEach( produto =>{
                  let produtoTotal = produtos[produto.id] || {...produto,total:0}
                  produtoTotal.total =  produtoTotal.total + produto.quantidade
                  produtos[produto.id] = {...produtoTotal}
              })
          })

          return produtos
      },
      tooglepago:function(pedido){
          let pago = !pedido.pago
          this.$store.dispatch('updatePedido',{id:pedido.id, pago })
      },

      apagarPedido:async function(pedido){
          let res = await this.$store.dispatch('removePedido',pedido)
          this.$router.replace("/admin/pedidos")
      },

      imprimir:function(){
        window.print();
      }

  }

}
</script>
